import VueRouter from 'vue-router';
import store from '../store/store'

// Pages
import Login from '@/views/Login/Index.vue';
import Welcome from '@/views/Welcome/Index.vue';
import NewSupportRequest from '@/views/NewSupportRequest/Index.vue';
import TermsOfUse from '@/views/TermsOfUse/Index.vue';
import EditCustomer from '@/views/Customer/EditCustomer/Index.vue';
import Locked from '@/views/Customer/Locked/Index.vue';
import CloseCases from '@/views/Customer/Cases/Close/Index.vue';
import OpenCases from '@/views/Customer/Cases/Open/Index.vue';
import CallCenterIndex from '@/views/CallCenter/Index.vue';
import SettingsCallCenterIndex from '@/views/CallCenter/Settings/Index.vue';
import SelectedCustomer from '@/views/CallCenter/SelectedCustomer.vue';
import SelectedGCS from '@/views/CallCenter/SelectedGCS.vue';
import { TokenHelper } from '../common/utils/TokenHelper';

const routes = [
  {
    path: '*',
    redirect: { name: 'Index' },
  },
  {
    name: 'Index',
    path: '/login',
    component: Login,
    meta: { title: 'Anmeldung - Kundenportal' },
    beforeEnter(to, from, next) { controlWelcomePage(to, from, next); },
  },
  {
    name: 'CallCenterIndex',
    path: '/callcenter',
    component: CallCenterIndex,
    meta: { title: 'Kunde suchen - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'SettingsCallCenterIndex',
    path: '/callcenter/settings',
    component: SettingsCallCenterIndex,
    meta: { title: 'Einstellungen - Kundenportal' },

    beforeEnter(to, from, next) { controlSettingPage(to, from, next); },
  },
  {
    name: 'SelectedCustomer',
    path: '/selected-customer/:id',
    component: SelectedCustomer,
    meta: { title: 'Kunde - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'SelectedGCS',
    path: '/selected-gcs/',
    component: SelectedGCS,
    meta: { title: 'Kunde - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'Welcome',
    path: '/welcome/:id',
    component: Welcome,
    meta: { title: 'Startseite - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'TermsOfUse',
    path: '/terms-of-use/:id',
    component: TermsOfUse,
    meta: { title: 'Nutzungsbedingungen - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'NewSupportRequest',
    path: '/new-support-request/:id',
    component: NewSupportRequest,
    meta: { title: 'Supportanfrage - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'EditCustomer',
    path: '/edit-customer/:id',
    component: EditCustomer,
    meta: { title: 'Daten ändern - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'Locked',
    path: '/locked',
    meta: { title: 'Zugang deaktiviert - Kundenportal' },
    component: Locked,
  },
  {
    name: 'OpenCases',
    path: '/open-cases/:id',
    component: OpenCases,
    meta: { title: 'Offene Anfragen - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
  {
    name: 'CloseCases',
    path: '/close-cases/:id',
    component: CloseCases,
    meta: { title: 'Geschlossene Anfragen - Kundenportal' },
    beforeEnter(to, from, next) { controlAuthenticate(to, from, next); },
  },
];

function controlAuthenticate(to, from, next) {
  if (localStorage.getItem('TOKEN') !== null) {
    if (TokenHelper.getUserInformation() == undefined) {
      saveToken();
      next();
    } else if (TokenHelper.isExpired()) {
      sessionStorage.setItem('exp', 'true');
      next('/');
    } else {
      next();
    }
  } else {
    sessionStorage.setItem('auth', 'false');
    next('/');
  }
}

function controlWelcomePage(to, from, next) {
  if (localStorage.getItem('TOKEN') !== null) {
    saveToken();
    store.getters['user/isCustomer'] ?
      isCustomerLocked(to, from, next) :
      next({ name: 'CallCenterIndex' });
  } else {
    next();
  }
}

function isCustomerLocked(to, from, next) {
  const loginState = store.getters['user/getState'];
  if (loginState == 5) {
    next({ name: 'Locked' });
  } else {
    next({ name: 'Welcome', params: { id: store.getters['user/getDebtorNumber'] } });
  }
}

function controlSettingPage(to, from, next) {
  if (localStorage.getItem('TOKEN') !== null) {
    saveToken();
    const isCallCenterAdmin = store.getters['user/isCallCenterAdmin'];
    isCallCenterAdmin ? next() : next({ name: 'CallCenterIndex' });
  } else {
    next();
  }
}

function saveToken() {
  TokenHelper.saveToken(localStorage.getItem('TOKEN'), null);
  store.dispatch('user/setUser', TokenHelper.getUserInformation());
}

export const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'is-active',
});
